const QuestionsPlacement = {
  TOP: 'TOP',
  BOTTOM: 'BOTTOM',
  LEFT: 'LEFT',
  RIGHT: 'RIGHT'
};

export default QuestionsPlacement;



// WEBPACK FOOTER //
// ./src/types/QuestionsPlacementType.js